import { Injectable, inject } from "@angular/core";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { jwtDecode } from "jwt-decode";
import { unpackRules } from "@casl/ability/extra";
import { Ability } from "@casl/ability";
import { consoleGrouped } from "src/app/support/console";
import { LocalStorageService } from "src/app/services/local-storage.service";

@Injectable()
export class EnableAbac {
  private readonly bootstrapService = inject(BootstrapService);
  private readonly ability = inject(Ability);
  private readonly localStorageService = inject(LocalStorageService);

  async canActivate(): Promise<void> {
    const currentMemberAuth = this.bootstrapService.getCurrentMemberAuth()!;
    const decodedJwt = jwtDecode<{ rules: Array<any> }>(
      currentMemberAuth.token
    );

    // chiave localStorage impostata da sviluppatore in console
    if (
      this.localStorageService.getItem("debug-disable-all-roles") &&
      this.localStorageService.getItem("debug-disable-all-roles") === "1"
    ) {
      this.ability.update([]);
    } else {
      this.ability.update(unpackRules(decodedJwt.rules));
    }

    consoleGrouped("[CASL] Ability rules", () =>
      this.ability.rules.map((rule) => {
        return `${rule.subject.join(",")} -> ${rule.action.join(
          ","
        )} // ${JSON.stringify(rule.conditions)}`;
      })
    );
  }
}
